import React, {useEffect} from 'react'
import Button from '@components/Button'
import Checkbox from '@components/fields/Checkbox'
import {websiteInitialData_cached_website} from '@data/queries/website/__generated__/websiteInitialData_cached'
import doesCountryRequireCookies from '@helpers/websites/doesCountryRequireCookies'
import useLocalStorageState from '@hooks/useLocalStorageState'
import useState from '@hooks/useState'
import Link from 'next/link'
import {Field, Form} from 'simple-react-form'

import PeruSelectCookies from './PeruSelectCookies'

import styles from './styles.module.css'

const isPeruWebsite = (countryCode: string) => {
  return countryCode === 'PE'
}

export default function CookiesBanner({website}: {website: websiteInitialData_cached_website}) {
  const [show, setShow] = useState(true)
  const [showOptions, setShowOptions] = useState(false)
  const {countryCode: websiteCountryCode} = website
  const [prompCookies, setPrompCookies] = useLocalStorageState('prompCookies', null)
  const [cookiesSelected, selectCookies] = useState({
    necessaryCookie: true,
    marketingCookie: false,
    preferenceCookie: false,
    statisticsCookie: false
  })

  const countryRequiresCookies = doesCountryRequireCookies(websiteCountryCode)

  const autoAcceptCookiesIfAble = () => {
    if (countryRequiresCookies) {
      return
    }

    const info = {userClickAccepted: true, date: new Date().getTime()}
    setPrompCookies(JSON.stringify(info))
  }

  const hasCookiePolicy = !!website.terms.website_cookies

  useEffect(() => {
    autoAcceptCookiesIfAble()
  }, [])

  if (!show || prompCookies) return null

  if (!countryRequiresCookies) {
    return null
  }

  const handleButton = (accepted = true) => {
    const acceptedCookies =
      (cookiesSelected.marketingCookie ||
        cookiesSelected.preferenceCookie ||
        cookiesSelected.statisticsCookie ||
        !hasCookiePolicy) &&
      accepted

    const info = {userClickAccepted: acceptedCookies, date: new Date().getTime()}
    setShow(false)
    setPrompCookies(JSON.stringify(info))
  }

  if (hasCookiePolicy) {
    return (
      <div className={styles.container}>
        <div className={styles.title}>Politica de Cookies</div>

        {isPeruWebsite(websiteCountryCode) ? (
          <PeruSelectCookies
            cookiesSelected={cookiesSelected}
            selectCookies={selectCookies}
            handleButton={handleButton}
          />
        ) : (
          <div>
            <div className={styles.message}>
              El presente sitio web de Get Justo S.A.C. utiliza una cookie de marketing que nos
              permite analizar los posibles intereses y/o necesidades de los usuarios que aceptan su
              activación, con el propósito de que a dichos usuarios se les pueda remitir anuncios
              publicitarios que se ajusten a su perfil individual. Lo anterior, de conformidad con
              lo establecido en la{' '}
              <Link href={`/documentos-legales/cookies`}>Política de Cookies</Link>, documento que
              es supletoriamente aplicable al presente consentimiento.
            </div>
            <div>
              <br />
              ¿Nos otorga su consentimiento libre, expreso e informado para el uso de la cookie de
              marketing?
            </div>
            <Form state={cookiesSelected} onChange={selectCookies}>
              <div className={styles.cookiesRow}>
                <Field
                  fieldName="necessaryCookie"
                  type={Checkbox}
                  label={'Necesarias'}
                  value={true}
                  disabled={true}
                />
                <Field fieldName="marketingCookie" type={Checkbox} label={'Marketing'} />
                <Field fieldName="preferenceCookie" type={Checkbox} label={'Preferencias'} />
                <Field fieldName="statisticsCookie" type={Checkbox} label={'Estadística'} />
              </div>
            </Form>

            <div className={styles.cookieButtonsRow}>
              <Button onClick={() => handleButton(false)}>No Acepto</Button>
              <div className={styles.buttonSpacer}></div>
              <Button primary onClick={() => handleButton(true)}>
                Acepto
              </Button>
            </div>
          </div>
        )}
      </div>
    )
  }

  return (
    <div className={styles.container}>
      <div className={styles.title}>Politica de Cookies</div>
      {showOptions ? (
        <div className={styles.message}>
          <strong>Funcionales</strong>
          <p>
            Son las que permiten la navegación óptima y el acceso a áreas seguras de la página web.
            La página web no podrá funcionar adecuadamente sin estas cookies. Con éstas también nos
            aseguramos que se cumpla la ley de protección de datos personales. Estas cookies no
            almacenan ninguna información de identificación personal.
          </p>
          <br />
          <strong>Analíticas y optimización</strong>
          <p>
            Son aquellas que permiten al Editor de las mismas, el seguimiento y análisis del
            comportamiento de los usuarios de los sitios web a los que están vinculados.
          </p>
        </div>
      ) : (
        <div className={styles.message}>
          Nos preocupamos por mejorar tu experiencia de compra, sin descuidar la protección de tus
          datos personales. En consecuencia utilizamos dos tipos de cookies las funcionales y las
          Analíticas y Optimización.
          <br />
          ¿Acepta el uso de las cookies?
        </div>
      )}
      <div className={styles.buttonsContainer}>
        <Button
          onClick={() => {
            if (showOptions) {
              handleButton(false)
            } else {
              setShowOptions(true)
            }
          }}>
          {showOptions ? 'Solo las funcionales' : 'Configurar cookies'}
        </Button>
        <Button primary onClick={handleButton}>
          {showOptions ? 'Sí Acepto todas' : 'Sí Acepto'}
        </Button>
      </div>
    </div>
  )
}
